var _defs, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.278,
    height: 24,
    viewBox: "0 0 34.278 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "youtube_svg__aa",
    d: "M33.572 3.755A4.294 4.294 0 0030.551.734C27.869 0 17.139 0 17.139 0S6.41 0 3.727.706A4.381 4.381 0 00.706 3.755 45.249 45.249 0 000 12a45.083 45.083 0 00.706 8.245 4.3 4.3 0 003.021 3.021C6.437 24 17.139 24 17.139 24s10.729 0 13.412-.706a4.3 4.3 0 003.021-3.021 45.263 45.263 0 00.706-8.245s.028-5.59-.706-8.273zm-19.85 13.384V6.861L22.644 12zm0 0"
  })));
}

export default SvgYoutube;